(() => {
  const init = (root) => {
    if (!root || root.dataset.mjrPromotorasReady === 'true') return;
    root.dataset.mjrPromotorasReady = 'true';

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        if (!selector || selector === '#') return;
        const target = document.querySelector(selector);
        if (!target) return;

        event.preventDefault();
        const desktopScroller = window.matchMedia('(min-width: 990px)').matches
          ? document.querySelector('.page-wrapper')
          : null;
        const top = target.getBoundingClientRect().top
          + (desktopScroller ? desktopScroller.scrollTop : window.scrollY)
          - 104;
        (desktopScroller || window).scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        window.history.replaceState(null, '', selector);
      });
    });

    const revealItems = [...root.querySelectorAll('.mjr-promotoras-reveal')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    root.querySelectorAll('[data-mjr-testimonials]').forEach((carousel) => {
      const slides = [...carousel.querySelectorAll('[data-mjr-testimonial-slide]')];
      const previous = carousel.querySelector('[data-mjr-testimonial-prev]');
      const next = carousel.querySelector('[data-mjr-testimonial-next]');
      const dots = carousel.querySelector('[data-mjr-testimonial-dots]');
      if (slides.length < 2 || !dots) return;

      let active = 0;
      let timer;
      const dotButtons = slides.map((_, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Ver testimonio ${index + 1}`);
        button.addEventListener('click', () => show(index));
        dots.appendChild(button);
        return button;
      });

      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dotButtons.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
      };
      const restart = () => {
        window.clearInterval(timer);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), 6500);
      };
      previous?.addEventListener('click', () => { show(active - 1); restart(); });
      next?.addEventListener('click', () => { show(active + 1); restart(); });
      carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
      carousel.addEventListener('mouseleave', restart);
      show(0);
      restart();
    });
  };

  const boot = () => document.querySelectorAll('[data-mjr-promotoras]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
